// Media-Query als React-Zustand (z. B. Handy-Breite), damit sich die DOM-Reihenfolge je Layout ändern kann.
import { useSyncExternalStore } from 'react';

export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', cb);
      return () => mq.removeEventListener('change', cb);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export const MOBIL = '(max-width: 820px)';
